import React, { useEffect, useState } from 'react'
import { BreathAPIs } from '../../../APIs/BreathAPIs';
import { toast } from 'react-toastify';
import {Select, Button} from 'antd'
import styles from './requestApprove.module.css'

function RequestApproval({siteId, setShowRequestForApproval, approvalStage, setApprovalStage}) {
    const [approverList, setApproverList] = useState([])
    const [selectedApproverList, setSelectedApproverList] = useState([])
    const [isSubmitting, setIsSubmitting] = useState(false)
    const sendSiteTrackerForApproval = async ()=>{
        console.log("selectedApproverList: ", selectedApproverList)
        console.log("selectd site data; ", siteId)
        try{
          setIsSubmitting(true)
          let response = await BreathAPIs.sendSiteForApproval(siteId, selectedApproverList)
          console.log("rsponse: ",response)
        if(response.status === 200){
          toast.success("Send For Approval")
          setApprovalStage("PendingApproval")
          setShowRequestForApproval(false)

        }else{
          toast.error("something went wrong! ")
        }
        }catch(error){
          console.log("error in sending for approval;", error.message)
          toast.error(error.message)
        }finally{
          setIsSubmitting(false)
        }

    }
    const getApproverList = async () => {
        let response = await BreathAPIs.getSiteApproverList();
        if (response.status !== 200) {
          console.log("Error in fetching approver list");
          toast.error("Error in fetching approver list");
        } else {
          console.log("Approver List: ", response.data.approverList);
          setApproverList(response.data.approverList);
        }
      };
    useEffect(()=>{
        getApproverList()
    }, [])
  return (
    <div>
        <div className={styles.requestApprovalContainer}>
          <h6>Forward for approval</h6>
            <div className={styles['selection-div']}>
              
            <Select
              showSearch
              placeholder="Select an approver"
              optionFilterProp="children"
              mode="multiple"
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
              style={{ width: "100%" }}
              onChange={(values) => setSelectedApproverList(values)}
            >
              {approverList.map((approver) => (
                <Select.Option on key={approver._id} value={approver._id}>
                  {approver.firstName} {approver.lastName}
                </Select.Option>
              ))}
            </Select>
            </div>
            <div className={styles['button-div']}>
            <Button
              style={{background: "#18365e", color: "white"}}
              type="button"
              loading={isSubmitting}
              disabled={selectedApproverList.length === 0}
              onClick={() => {
                sendSiteTrackerForApproval();
              }}
            >
              Send for Approval
            </Button>
            </div>
          </div>
    </div>
  )
}

export default RequestApproval